import { MemoirRoute } from '@/modules/memoir/routes/MemoirRoute';
import { ThemeType } from '@/modules/core/app/constants/ThemeType';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export const router: CurrentEstateRouteConfig[] = [
  CurrentEstateRouteConfig.factory({
    name: MemoirRoute.LEGACY_LETTERS.name,
    path: `/${MemoirRoute.LEGACY_LETTERS.path}`,
    meta: { theme: ThemeType.MEMOIR },
    component: () => import('/@/modules/memoir/pages/LegacyLettersPage.vue')
  }).build() as CurrentEstateRouteConfig
];
